/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Signature/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import AddAction from './AddAction/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Signature({
  children,
  viewPath = "/DesignSystem/PreviewDocumentModal/Content/Content/HtmlFile/Content/Content/Content/Content/Actions/Signature"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let editorHasSignatureValueData = fromData.useDataFormat({ viewPath,
context: 'editor',
path: 'hasSignature',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: editorHasSignatureValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'AddAction'}>
<AddAction
  viewPath={`${viewPath}/AddAction`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}